module.exports = __webpack_public_path__ + "img/icon_5_75.2f10311b.png";